var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"popup"}},[_c('div',{staticClass:"button-go",on:{"click":_vm.go}},[_c('span',[_vm._v("马上出发")])])])}
var staticRenderFns = []

export { render, staticRenderFns }